import {
  type AnyContainerLayout,
  type StackContainerLayout,
} from '@wix/document-services-types'

export function assertStackContainerLayout(
  containerLayout: AnyContainerLayout | Record<string, unknown>,
): asserts containerLayout is StackContainerLayout {
  if (
    'type' in containerLayout &&
    containerLayout.type !== 'StackContainerLayout'
  ) {
    throw new Error('Not a stack-container layout.')
  }
}
